import React from 'react';
import {
  auth, logAnalyticsEvent, mintCustomToken, updatePartialUserData,
  upsertContacts,
} from '../../../firebaseApp';
import { navigate } from 'gatsby';
import { useStore } from '../../store/store';
import { SongType } from '../../helpers/typings';

export function validateEmail(value) {
  const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (value.match(validRegex)) return true;
  return false;
}

export const GoogleIcon: React.FC = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.0005 12.7326C23.0005 11.8693 22.9291 11.2393 22.7744 10.5859H12.7148V14.4826H18.6196C18.5006 15.4509 17.8577 16.9093 16.4291 17.8892L16.4091 18.0197L19.5897 20.4344L19.8101 20.4559C21.8338 18.6242 23.0005 15.9292 23.0005 12.7326Z"
      fill="#4285F4"
    />
    <path
      d="M12.714 22.9996C15.6068 22.9996 18.0353 22.0662 19.8092 20.4562L16.4282 17.8895C15.5235 18.5078 14.3092 18.9395 12.714 18.9395C9.88069 18.9395 7.47596 17.1079 6.61874 14.5762L6.49309 14.5866L3.18583 17.095L3.14258 17.2128C4.90446 20.6428 8.5235 22.9996 12.714 22.9996Z"
      fill="#34A853"
    />
    <path
      d="M6.62095 14.5775C6.39476 13.9241 6.26386 13.2241 6.26386 12.5008C6.26386 11.7774 6.39476 11.0774 6.60905 10.4241L6.60306 10.285L3.25435 7.73633L3.14478 7.7874C2.41862 9.21075 2.00195 10.8091 2.00195 12.5008C2.00195 14.1924 2.41862 15.7907 3.14478 17.2141L6.62095 14.5775Z"
      fill="#FBBC05"
    />
    <path
      d="M12.7141 6.05997C14.7259 6.05997 16.083 6.91163 16.8569 7.62335L19.8807 4.73C18.0236 3.03834 15.6069 2 12.7141 2C8.52353 2 4.90447 4.35665 3.14258 7.78662L6.60686 10.4233C7.47598 7.89166 9.88073 6.05997 12.7141 6.05997Z"
      fill="#EB4335"
    />
  </svg>
);

export const AppleIcon: React.FC = () => (
  <svg width="25" height="25" viewBox="18 14 20 23" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ position: 'relative', top: '-3px' }}>
    <path d="M28.2226562,20.3846154 C29.0546875,20.3846154 30.0976562,19.8048315 30.71875,19.0317864 C31.28125,18.3312142 31.6914062,17.352829 31.6914062,16.3744437 C31.6914062,16.2415766 31.6796875,16.1087095 31.65625,16 C30.7304687,16.0362365 29.6171875,16.640178 28.9492187,17.4494596 C28.421875,18.06548 27.9414062,19.0317864 27.9414062,20.0222505 C27.9414062,20.1671964 27.9648438,20.3121424 27.9765625,20.3604577 C28.0351562,20.3725366 28.1289062,20.3846154 28.2226562,20.3846154 Z M25.2929688,35 C26.4296875,35 26.9335938,34.214876 28.3515625,34.214876 C29.7929688,34.214876 30.109375,34.9758423 31.375,34.9758423 C32.6171875,34.9758423 33.4492188,33.792117 34.234375,32.6325493 C35.1132812,31.3038779 35.4765625,29.9993643 35.5,29.9389701 C35.4179688,29.9148125 33.0390625,28.9122695 33.0390625,26.0979021 C33.0390625,23.6579784 34.9140625,22.5588048 35.0195312,22.474253 C33.7773438,20.6382708 31.890625,20.5899555 31.375,20.5899555 C29.9804688,20.5899555 28.84375,21.4596313 28.1289062,21.4596313 C27.3554688,21.4596313 26.3359375,20.6382708 25.1289062,20.6382708 C22.8320312,20.6382708 20.5,22.5950413 20.5,26.2911634 C20.5,28.5861411 21.3671875,31.013986 22.4335938,32.5842339 C23.3476562,33.9129053 24.1445312,35 25.2929688,35 Z" fill="#000000" fillRule="nonzero"/>
  </svg>
);

export const FacebookIcon: React.FC = () => (<svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="16" cy="16.5" r="14" fill="#0C82EE"/>
  <path d="M21.2137 20.7816L21.8356 16.8301H17.9452V14.267C17.9452 13.1857 18.4877 12.1311 20.2302 12.1311H22V8.76699C22 8.76699 20.3945 8.5 18.8603 8.5C15.6548 8.5 13.5617 10.3929 13.5617 13.8184V16.8301H10V20.7816H13.5617V30.3345C14.2767 30.444 15.0082 30.5 15.7534 30.5C16.4986 30.5 17.2302 30.444 17.9452 30.3345V20.7816H21.2137Z" fill="white"/>
</svg>);

export const ensureUserIsInContactList = async (email: string, name: string, country: string, source?: string) => {
  const firstName = name.split(' ')[0];
  const lastName = name.split(' ').slice(1).join(' ');
  try {
    await upsertContacts({
      list_ids: [],
      contacts: [
        {
          email,
          first_name: firstName,
          last_name: lastName,
          country,
          source,
        },
      ],
    });
  } catch (e) {
    logAnalyticsEvent('subscribe-response-error', { error: e });
    return;
  }
};

export const markAppDownloadedInMailchimp = async (email: string) => {
  try {
    await upsertContacts({
      list_ids: [],
      contacts: [
        {
          email,
          custom_fields: {
            hasDownloadedApp: 'true',
          },
        },
      ],
    });
  } catch (e) {
    logAnalyticsEvent('markAppDownloadedInMailchimp-response-error', { error: e });
    return;
  }
};

export const addMarketingConsentInMailchimp = async (email: string) => {
  try {
    await upsertContacts({
      list_ids: [],
      contacts: [
        {
          email,
          custom_fields: {
            isMarketingEmailApproved: 'true',
          },
        },
      ],
    });
  } catch (e) {
    logAnalyticsEvent('addMarketingConsentInMailchimp-response-error', { error: e });
    return;
  }

};

const OPEN_APP_URL = 'amplio://open/';

function handleAppOpenFailure(url: string) {
  useStore.setState({
    showDownloadPopup: true,
    showFailureToOpenAppDialog: true,
    redirectAfterLogin: url,
  });
}

export async function openCustomProtocolUrl(url = OPEN_APP_URL) {
  // Set a flag in the user's data to indicate that we are waiting for the app
  // to open, at which point the app should set this flag back to false to
  // signal to the website that the app has opened successfully.
  console.debug('Opening app with base URL:', url.split('?')[0]);
  updatePartialUserData({ waitingForSongToOpenInApp: true });

  navigate(url);

  useStore.setState({ openAppAfterLogin: false });

  // Check if waitingForSongToOpenInApp is still true after 15 seconds, so we
  // can assume the app did not open successfully and handle the failure.
  setTimeout(() => {
    console.debug('Timeout reached, checking if app opened successfully...');
    if (useStore.getState().userData?.waitingForSongToOpenInApp) {
      console.debug('App did not open successfully, suggesting download');
      updatePartialUserData({ waitingForSongToOpenInApp: false });
      handleAppOpenFailure(url);
    } else {
      console.debug('App opened successfully');
    }
  }, 15000);
}

export async function openAppWithAuthToken() {
  const idToken = await auth.currentUser?.getIdToken();
  const desktopAuth = await mintCustomToken({ idToken });
  await openCustomProtocolUrl(`${OPEN_APP_URL}?auth=${desktopAuth.data.token}`);
}

export function handleSongPlayClickRedirect(url: string, song: SongType) {
  openCustomProtocolUrl(url);
  logAnalyticsEvent('song_play_click', {
    songId: song.songId,
    songTitle: song.title,
    songArtist: song.artist,
    songVersion: song.songVersion,
    userId: auth.currentUser.uid,
  });
}
